import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { CustomerEffects } from "./effects";
import { CustomerDbService } from "./service/customer-db.service";

@NgModule({
    imports: [CommonModule, EffectsModule.forFeature([CustomerEffects])],
    providers: [CustomerEffects, CustomerDbService],
})
export class CustomerStoreModule {}
